import types from "./types";

// IS LOADING FLAG
export const startCommunityLoading = () => ({
    type: types.COMMUNITY_LOADING,
});
// DONE LOADING FLAG
export const endCommunityLoading = () => ({
    type: types.COMMUNITY_LOADED,
});
// LOADING ERROR
export const setCommunityError = (error) => ({
    type: types.SET_COMMUNITY_ERROR,
    error,
});

export const createCommunityStart = () => ({
    type: types.CREATE_COMMUNITY_START,
});

export const createCommunitySuccess = (community) => ({
    type: types.CREATE_COMMUNITY_SUCCESS,
    payload: community, // unused
});

export const createCommunityError = (error) => ({
    type: types.CREATE_COMMUNITY_ERROR,
    payload: error,
});

export const cleanUpCommunity = () => ({
    type: types.CLEAN_UP_COMMUNITY,
});

export const deleteCommunityStart = () => ({
    type: types.DELETE_COMMUNITY_START,
});

export const deleteCommunitySuccess = () => ({
    type: types.DELETE_COMMUNITY_SUCCESS,
});

export const deleteCommunityError = (error) => ({
    type: types.DELETE_COMMUNITY_ERROR,
    payload: error,
});

export const moveCommunityStart = () => ({
    type: types.MOVE_COMMUNITY_START,
});

export const moveCommunitySuccess = () => ({
    type: types.MOVE_COMMUNITY_SUCCESS,
});

export const moveCommunityError = (error) => ({
    type: types.MOVE_COMMUNITY_ERROR,
    payload: error,
});

// export const duplicateCommunityStart = () => ({
//     type: types.DUPLICATE_COMMUNITY_START,
// });

// export const duplicateCommunitySuccess = () => ({
//     type: types.DUPLICATE_COMMUNITY_SUCCESS,
// });

// export const duplicateCommunityError = (error) => ({
//     type: types.DUPLICATE_COMMUNITY_ERROR,
//     payload: error,
// });

export const batchDeleteCommunityStart = () => ({
    type: types.BATCH_DELETE_COMMUNITY_START,
});

export const batchDeleteCommunitySuccess = () => ({
    type: types.BATCH_DELETE_COMMUNITY_SUCCESS,
});

export const batchDeleteCommunityError = (error) => ({
    type: types.BATCH_DELETE_COMMUNITY_ERROR,
    payload: error,
});

export const fetchCommunityStart = () => ({
    type: types.FETCH_COMMUNITY_START,
});

export const fetchCommunitySuccess = ({
    communityId,
    communityDetails,
    modelDir,
    modelData,
    ecmInputMap,
    parametricResults,
    configuration,
}) => ({
    type: types.FETCH_COMMUNITY_SUCCESS,
    payload: { communityId, communityDetails, modelDir, modelData, ecmInputMap, parametricResults, configuration },
});

export const fetchCommunityError = (error) => ({
    type: types.FETCH_COMMUNITY_ERROR,
    payload: error,
});

// ****************************************************
// UPDATING COMMUNITY DATA
// ****************************************************
export const setCommunityName = (newName) => ({
    type: types.UPDATE_COMMUNITY_DETAILS,
    communityDetails: { name: newName },
});

export const setLocation = (weatherLocation) => ({
    type: types.UPDATE_COMMUNITY_DETAILS,
    communityDetails: { weatherLocation },
});

export const setLastEdited = (lastEdited) => ({
    type: types.UPDATE_COMMUNITY_DETAILS,
    communityDetails: { lastEdited },
});

export const updateCommunitySettings = ({ upgrades }) => ({
    type: types.UPDATE_COMMUNITY_SETTINGS,
    payload: { uiSettings: { upgrades } },
});

export const addCommModel = ({ modelId, modelDetails, modelData }) => ({
    type: types.ADD_MODEL_TO_COMMUNITY,
    payload: { modelId, modelDetails, modelData },
});

export const removeCommModel = ({ modelId, regionCode }) => ({
    type: types.REMOVE_MODEL_FROM_COMMUNITY,
    payload: { modelId, regionCode },
});

export const setModelDuplicates = (modelId, copyDirections) => ({
    type: types.UPDATE_MODEL_DIR_COPIES,
    payload: { modelId, copyDirections },
});

export const setInitData = ({ communityDetails, modelDir, modelData }) => ({
    type: types.SAVE_COMMUNTIY_DATA,
    payload: { communityDetails, modelDir, modelData },
});

export const saveEcmInputMapStart = () => ({
    type: types.SAVE_COMM_ECM_INPUT_MAP_START,
});

export const saveEcmInputMapSuccess = (ecmInputMap) => ({
    type: types.SAVE_COMM_ECM_INPUT_MAP_SUCCESS,
    payload: { ecmInputMap },
});

export const saveEcmInputMapError = (error) => ({
    type: types.SAVE_COMM_ECM_INPUT_MAP_ERROR,
    payload: error,
});

export const saveCommunityStart = () => ({
    type: types.SAVE_COMMUNITY_START,
});

export const saveCommunitySuccess = () => ({
    type: types.SAVE_COMMUNITY_SUCCESS,
});

// ****************************************************
// SYNCHRONOUS ACTIONS
// ****************************************************

export const addUpgradeToCommunity = (sectionType, upgrade) => ({
    type: types.ADD_UPGRADE_TO_COMMUNITY,
    payload: { sectionType, upgrade },
});

export const removeUpgradeFromCommunity = (sectionType, upgradeId) => ({
    type: types.REMOVE_UPGRADE_FROM_COMMUNITY,
    payload: { sectionType, upgradeId },
});

export const updateCommunityEcmInputMapUpgrade = (sectionType, upgradeId, upgrade) => ({
    type: types.UPDATE_COMM_ECM_INPUT_MAP_UPGRADE,
    payload: { sectionType, upgradeId, upgrade },
});

export const updateCommunityDetails = (communityDetails) => ({
    type: types.UPDATE_COMM_DETAILS,
    payload: { communityDetails },
});

export const updateFuelCosts = (fuelType, name, value) => ({
    type: types.UPDATE_COMM_FUEL_COSTS,
    payload: { fuelType, name, value },
});

export const updateRunResults = (runResults) => ({
    type: types.UPDATE_RUN_RESULTS,
    payload: runResults,
});

export const mergeCommunityEcmValidationResults = (remoteEcmInputMap) => ({
    type: types.MERGE_COMMUNITY_ECM_VALIDATION_RESULTS,
    payload: { remoteEcmInputMap },
});
